import { klona } from 'klona/lite'

// Advanced https://vueuse.org/core/useCloned/ that can also handle Dates. Note: We could use an even mightier mode of klona if we wanted to: https://github.com/lukeed/klona#modes
export default <T>(value: MaybeRefOrGetter<T>) => useCloned(value, { clone: klona })
